<main class="app-container">
  <app-nav
    [windowMode]="windowMode"
    (menuMenuBtnToggle)="handleSidebar(true)"
  ></app-nav>
  <mat-sidenav-container class="main-container" autosize [hasBackdrop]="false">
    <mat-sidenav
      #drawer
      class="main-container-sidenav"
      [mode]="windowMode === 'large' ? 'side' : 'over'"
    >
      @if (isNavOpen$ | async) {
      <app-sidebar (shouldCloseSidebar)="handleSidebar(false)"></app-sidebar>
      }
    </mat-sidenav>

    <mat-sidenav-content class="main-container-content">
      <section class="main-container-content-wrapper">
        <app-breadcrumb></app-breadcrumb>
        <router-outlet></router-outlet>
      </section>
    </mat-sidenav-content>
  </mat-sidenav-container>
</main>
